import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function VideoSection() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-12 pb-8 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center" data-id="element-211">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="relative rounded-[2rem] overflow-hidden shadow-2xl aspect-[9/16] max-w-sm mx-auto bg-brand-text mb-8" data-id="element-212">
        <video src="https://cdn.magicpatterns.com/uploads/xf2qd7vBv6BCj5C5KYcv4R/WhatsApp Video 2026-03-29 at 23.21.07.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-213" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} data-id="element-214">
        <Button onClick={scrollToPurchase} className="text-lg px-12 py-6 shadow-xl" data-id="element-215">
          QUIERO APRENDER AHORA
        </Button>
      </motion.div>
    </section>;
}